var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"social-instagram__grid"},_vm._l((_vm.items),function(item,i){return _c(_setup.InstagramItem,{key:i,attrs:{"item":item,"index":i},on:{"item-click":_setup.onItemClick,"autoplay-toggle":(index, v) => _setup.emit('autoplay-toggle', index, v)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }